import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'


import './CoachAd.scss'

const CoachAd = (props) => {
  const { t } = useTranslation()

  return (
    <div className='coach-ad-wrapper'>
      <object data={props.adSrc}>
        <img src={props.fallback} className='coach-ad-img' alt={t('proShop.coachAd.imageAlt')} />
      </object>
    </div>
  )
}

CoachAd.propTypes = {
  adSrc: PropTypes.string,
  fallback: PropTypes.string,
}

export default CoachAd
